import React, { useEffect } from 'react';
import { ClassificationWall } from '@/features/classification';
import { MOCK_POSTS } from '@/core/services/interfaces/PostMockData';
import { CLASSIFICATION_EVENTS } from '@/features/classification/constants/events';

export const ClassificationWallDevPage: React.FC = () => {
  useEffect(() => {
    document.dispatchEvent(
      new CustomEvent(CLASSIFICATION_EVENTS.UPDATE_POSTS, {
        detail: { posts: MOCK_POSTS, totalCount: MOCK_POSTS.length },
      }),
    );
  }, []);

  return <ClassificationWall />;
};
